import React, {Component} from 'react'
import {
  Flex,
  Box,
  FormControl,
  FormLabel,
  Input,
  Stack,
  Link,
  Button,
  Heading,
  Text,
  VStack,
  Image,
  Alert,
  AlertIcon,
  AlertDescription,
} from '@chakra-ui/react'
import colors from '../../theme/colors'

class PasswordResetRequest extends Component {
  constructor(props) {
    super(props)
    this.state = {
      email: '',
      isSubmitting: false,
      error: '',
      success: false
    }
  }

  handleEmailChange = (value) => {
    this.setState({ email: value, error: '' })
  }

  handleSubmit = async () => {
    const { email } = this.state

    if (!email) {
      this.setState({ error: 'Email is verplicht.' })
      return
    }

    this.setState({ isSubmitting: true, error: '' })

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || ''}/request-password-reset`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify({ email })
      })

      const data = await response.json()

      if (data.success) {
        this.setState({
          success: true,
          isSubmitting: false
        })
      } else {
        this.setState({
          error: data.message || 'Er is een fout opgetreden.',
          isSubmitting: false
        })
      }
    } catch (error) {
      console.error('Error:', error)
      this.setState({
        error: 'Kan geen verbinding maken met de server.',
        isSubmitting: false
      })
    }
  }

  render() {
    const { error, success, isSubmitting } = this.state

    return (
      <Flex
        minH={'100vh'}
        align={'center'}
        justify={'center'}
        bg={colors.background.main}
        position="relative"
      >
        <Box bg={colors.primary.main} h="160px" w="100%" position="absolute" top="0">
          <VStack justify="center" h="100%" spacing={4}>
            <Image src="/volt_logo.png" boxSize="80px" alt="Demos Platform Logo" />
          </VStack>
        </Box>
        <Stack spacing={8} mx={'auto'} maxW={'lg'} w={{ base: '95%', sm: 'auto' }} py={12} px={{ base: 4, sm: 6 }} position="relative" zIndex="1" mt="120px">
          <VStack spacing={4} align={'center'}>
            <Heading fontSize={{ base: '3xl', sm: '4xl' }} textAlign="center">
              <Text as="span" color={colors.text.primary}>Wachtwoord </Text>
              <Text as="span" color={colors.primary.main}>Vergeten</Text>
              <Text as="span" color={colors.text.primary}>?</Text>
            </Heading>
            <Text fontSize={{ base: 'md', sm: 'lg' }} color={colors.text.secondary} textAlign="center" px={4}>
              Vul je emailadres in en we sturen je een resetcode
            </Text>
          </VStack>
          <Box
            rounded={'lg'}
            bg={colors.background.white}
            boxShadow={'lg'}
            p={{ base: 6, sm: 8 }}>
            {success ? (
              <VStack spacing={4}>
                <Alert status="success" borderRadius="md">
                  <AlertIcon />
                  <AlertDescription>
                    Als dit emailadres bestaat, is er een resetcode verstuurd. Controleer je inbox en klik op de knop hieronder om je wachtwoord te resetten.
                  </AlertDescription>
                </Alert>
                <Button
                  w="100%"
                  bg={colors.button.primary}
                  color={colors.text.white}
                  _hover={{
                    bg: colors.button.primaryHover,
                  }}
                  _active={{
                    bg: colors.button.primaryActive,
                  }}
                  onClick={() => this.props.onRouteChange('passwordResetConfirm')}
                >
                  Code Invoeren
                </Button>
                <Link
                  color={colors.text.link}
                  fontSize={'sm'}
                  fontWeight="600"
                  textDecoration="underline"
                  onClick={() => this.props.onRouteChange('login')}
                  cursor="pointer"
                  _hover={{ color: colors.text.linkHover }}
                >
                  Terug naar Inloggen
                </Link>
              </VStack>
            ) : (
              <Stack spacing={4}>
                {error && (
                  <Alert status="error" borderRadius="md">
                    <AlertIcon />
                    <AlertDescription>{error}</AlertDescription>
                  </Alert>
                )}
                <FormControl id="email">
                  <FormLabel>Email</FormLabel>
                  <Input
                    type="email"
                    placeholder="je@email.nl"
                    bg={colors.form.inputBg}
                    onChange={(event) => this.handleEmailChange(event.target.value)}
                  />
                </FormControl>
                <Stack spacing={10}>
                  <Button
                    bg={colors.button.primary}
                    color={colors.text.white}
                    _hover={{
                      bg: colors.button.primaryHover,
                    }}
                    _active={{
                      bg: colors.button.primaryActive,
                    }}
                    onClick={this.handleSubmit}
                    isLoading={isSubmitting}
                    loadingText="Versturen...">
                    Resetcode Versturen
                  </Button>
                  <Link
                    color={colors.text.link}
                    fontSize={'sm'}
                    fontWeight="600"
                    textDecoration="underline"
                    onClick={() => this.props.onRouteChange('login')}
                    cursor="pointer"
                    _hover={{ color: colors.text.linkHover }}
                    textAlign="center"
                  >
                    Terug naar Inloggen
                  </Link>
                </Stack>
              </Stack>
            )}
          </Box>
        </Stack>
      </Flex>
    )
  }
}

export default PasswordResetRequest
